var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-review"},[_c('CampaignList',{attrs:{"lbl":_vm.lbl,"isLoading":_vm.isLoading,"initListConfig":_vm.listConfig,"initFilterConfig":_vm.filterConfig,"busEvent":_vm.busCampaign,"type":'review'},on:{"toggleLoading":function($event){return _vm.toggleLoading($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }